import { createSelector } from 'reselect';
import { getNestedObject } from 'Utility/globalMethods';
export const getNested = (state, props) => getNestedObject(state, props);

export const getHome = (state, props) => state.Home[props];
export const getPromotions = (state, props) => state.Promotions[props];
export const getBackofficeUser = (state, props) => state.Users[props];
export const getTransactions = (state, props) => state.Transactions[props];
export const getGroups = (state, props) => state.Groups[props];
export const getAccount = (state, props) => state.Account[props];
export const getMerchant = (state, props) => state.Merchant[props];
export const getStore = (state, props) => state.Store[props];
export const getRegister = (state, props) => state.Register[props];
export const getShared = (state, props) => state.shared[props];
export const getCustomerCare = (state, props) => state.CustomerCare[props];
// @generator selectors:single

export const portalModalSelector = (state) => state.portalModal;
export const portalTemplateSelector = (state) => state.portalTemplate;
export const formSelector = (state) => state.form;
export const routeElectronicPurse = (state) => state.ElectronicPurse;
// @generator selectors:memoized
